
import * as tagsApi from "../api/tags"
import { handleApiError } from "./api-errors"

export const GET_TAGS_LIST = "GET_TAGS_LIST"

export const getAvailableTagsList = () => (dispatch) => {
    tagsApi.listObj()
        .then(res => {
            dispatch({
                type: GET_TAGS_LIST,
                payload: res
            })
        }).catch(err => dispatch(handleApiError(err)))
}

export const addTagToAvailable = (tag) => (dispatch) => {
    tagsApi.putObj({ name: tag })
        .then(() => dispatch(getAvailableTagsList()))
        .catch(err => dispatch(handleApiError(err)))
}

export const removeTagFromAvailable = (tag_id) => (dispatch) => {
    tagsApi.deleteObj(tag_id)
        .then(() => dispatch(getAvailableTagsList()))
        .catch(err => dispatch(handleApiError(err)))
}


export const editTag = (tag_id, tag) => (dispatch) => {
    tagsApi.patchObj(tag_id, { name: tag })
        .then(() => dispatch(getAvailableTagsList()))
        .catch(err => dispatch(handleApiError(err)))
}
